export enum LocalStorageKey {
  token = 'token',
  company = 'company',
  listPage = 'listPage',
  language = 'language',
  version = 'version',
  needsRestart = 'needsRestart',
  errorRepeat = 'errorRepeat',
  postLoginRedirect = 'postLoginRedirect',
}

export const setLocalStorageValue = <T>(key: LocalStorageKey, value: T) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getLocalStorageValue = <T>(key: LocalStorageKey): T | null => {
  const value = localStorage.getItem(key);

  if (!value) {
    return null;
  }

  try {
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
};

export const clearLocalStorageValue = (key: LocalStorageKey) => {
  localStorage.removeItem(key);
};

export const clearLocalStorage = () => {
  localStorage.clear();
};
